import styled from "styled-components";
import { Layout as antdLayout } from "antd";

export const Layout = styled(antdLayout)`
  .ant-layout-header {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
  }
  .ant-menu-light,
  .ant-menu-light .ant-menu-sub {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
  }
  .ant-menu-horizontal > .ant-menu-item:hover,
  .ant-menu-horizontal > .ant-menu-submenu:hover,
  .ant-menu-horizontal > .ant-menu-item-active,
  .ant-menu-horizontal > .ant-menu-submenu-active,
  .ant-menu-horizontal > .ant-menu-item-open,
  .ant-menu-horizontal > .ant-menu-submenu-open,
  .ant-menu-horizontal > .ant-menu-item-selected,
  .ant-menu-horizontal > .ant-menu-submenu-selected {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.LIGTH};
    color: ${({ theme }) => theme.PROPERTY.COLOR.LIGTH};
    border-bottom: ${({ theme }) => "2px solid " + theme.PROPERTY.BORDER.LIGTH};
  }
  .ant-menu-item:hover,
  .ant-menu-item-active,
  .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-submenu-active,
  .ant-menu-submenu-title:hover {
    color: ${({ theme }) => theme.PROPERTY.COLOR.LIGTH};
  }
  .ant-menu-horizontal {
    border-bottom: 0;
  }
  .ant-avatar {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  #card_main_page {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.SECONDARY};
  }
  .ant-collapse {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-collapse-content {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.BEACH};
  }
  .search > input,
  .search .ant-select-selection {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.WARNING};
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-list-split .ant-list-header {
    border-bottom: ${({ theme }) =>
      "1px solid " + theme.PROPERTY.BORDER.WARNING};
  }
  .ant-list-bordered .ant-list-item {
    border-bottom: ${({ theme }) =>
      "1px solid " + theme.PROPERTY.BORDER.WARNING};
  }
  .ant-list-item-action-split {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.WARNING};
  }
  .react-grid-item > .react-resizable-handle::after {
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.INFO};
  }
  .ant-btn {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DEFAULT};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.DEFAULT};
    color: ${({ theme }) => theme.PROPERTY.COLOR.DEFAULT};
  }
  .ant-btn-primary {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.PRIMARY};
    color: ${({ theme }) => theme.PROPERTY.COLOR.PRIMARY};
  }
  .ant-btn-danger {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DANGER};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.DANGER};
    color: ${({ theme }) => theme.PROPERTY.COLOR.DANGER};
  }
  .ant-typography {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    opacity: 0.65;
  }
  .ant-divider-inner-text {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-divider {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.WARNING};
  }
  .ant-tree li .ant-tree-node-content-wrapper {
    color: ${({ theme }) => theme.PROPERTY.COLOR.BEACH};
  }
  .ant-tree li span.ant-tree-switcher {
    color: ${({ theme }) => theme.PROPERTY.COLOR.BEACH};
  }
  .ant-tree li .ant-tree-node-content-wrapper:hover {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUCCESS};
  }
  .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUCCESS};
  }
  .ant-switch-checked {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUCCESS};
  }
  .ant-switch {
    border: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.SUCCESS};
  }
  .dashboard-background {
    background-color: none;
  }
  .dashboard-border {
    border: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.SECONDARY};
  }
  .dashboard-form {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .slider {
    border-left: ${({ theme }) =>
      "1px solid " + theme.PROPERTY.BORDER.SECONDARY};
  }
  .pure-table thead {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DARK};
    color: ${({ theme }) => theme.PROPERTY.COLOR.DARK};
  }
  .pure-table {
    border: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .pure-table td,
  .pure-table th {
    border-left: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .pure-table td {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUNSHINE};
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .pure-table tr {
    border-bottom: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
  }
  .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:hover {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.LIGTH};
    color: ${({ theme }) => theme.PROPERTY.COLOR.LIGTH};
  }
  .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .read {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
  }
  .fullscreen {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SECONDARY};
  }
  .react_time_range__tick_label {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
`;
